import React, { useEffect, useState } from 'react';
import { Card } from '@/components/ui/card';
import { Landmark, CheckCircle } from 'lucide-react';

// Every jurisdiction's charges on a reference premium, with the confirmation record beside each.
export default function ChargesByState({ api, classId, homeState }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/question-sets/charges?class_id=${classId}`).then(r => setData(r.data)).catch(() => setData(null));
  }, [api, classId]);
  if (!data) return null;
  const ordered = [...data.states].sort((a, b) => (a.state === homeState ? -1 : b.state === homeState ? 1 : 0));
  return (
    <Card className="p-4 rounded-sm bg-white" style={{ border: '1px solid rgba(136,150,168,0.2)' }} data-testid="charges-by-state-card">
      <div className="flex items-center gap-2 mb-2">
        <Landmark className="w-4 h-4" style={{ color: '#1A4C7C' }} />
        <p className="text-xs font-semibold uppercase tracking-wider" style={{ color: '#0D1B2A' }}>Statutory charges — {data.other_states?.length ? 'confirmed states' : 'all eight jurisdictions confirmed'}</p>
        <span className="ml-auto text-[10px] font-mono" style={{ color: '#5C6B7A' }}>on ${data.reference_premium.toLocaleString('en-AU')} gross · {data.effective_date}</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {ordered.map(s => {
          const home = s.state === homeState;
          return (
            <div key={s.state} className="p-2.5 rounded-sm" style={{ background: home ? 'rgba(26,76,124,0.06)' : '#F5F7FA', border: home ? '1px solid rgba(26,76,124,0.3)' : '1px solid transparent' }} data-testid={`charges-${s.state}`}>
              <div className="flex items-center justify-between">
                <p className="text-sm font-bold" style={{ color: '#0D1B2A' }}>{s.state}{home && <span className="text-[9px] font-normal ml-1" style={{ color: '#1A4C7C' }}>home state</span>}</p>
                <span className="text-[10px] flex items-center gap-1" style={{ color: '#1D9E75' }} data-testid={`charges-${s.state}-confirmed`}><CheckCircle className="w-3 h-3" /> {s.confirmed_on}</span>
              </div>
              <p className="text-xs mt-1" style={{ color: '#0D1B2A' }}>Duty <span className="font-mono font-semibold" data-testid={`charges-${s.state}-duty-rate`}>{s.duty_exempt ? 'nil' : s.duty_rate_display}</span> · GST 10% · {s.levy_applies ? 'levy applies' : 'no levy'}</p>
              <p className="text-[10px] font-mono mt-0.5" style={{ color: '#5C6B7A' }}>payable ${s.total_payable.toLocaleString('en-AU', { minimumFractionDigits: 2 })}</p>
              <p className="text-[10px] mt-1 leading-snug" style={{ color: '#5C6B7A' }}>{s.source}</p>
            </div>
          );
        })}
      </div>
      <p className="text-[10px] mt-2" style={{ color: '#5C6B7A' }}>{data.order}. {data.note}</p>
    </Card>
  );
}
